import React from 'react'
import CustomRangeSlider from 'components/CustomRangeSlider'
import Flex from 'components/Flex'
import {
  Wrapper,
  StyledP,
  RangeValues,
} from 'modules/Roles/ViewRole/CollegesTable/CollegeFilter/Styles/style'

const CandidateRangeFilter = ({
  candidateRangeMin,
  setCandidateRangeMin,
  candidateRangeMax,
  setCandidateRangeMax,
}) => {
  return (
    <Wrapper column>
      <CustomRangeSlider
        minValue={candidateRangeMin}
        setMinValue={setCandidateRangeMin}
        maxValue={candidateRangeMax}
        setMaxValue={setCandidateRangeMax}
        min={0}
        max={1000}
      />
      <Flex alignCenter>
        <StyledP>Range </StyledP>
        <RangeValues>
          {candidateRangeMin}-{candidateRangeMax}
        </RangeValues>
      </Flex>
    </Wrapper>
  )
}

export default CandidateRangeFilter
